import { useContext } from 'react'
import { Client, User } from '../contexts/parameters'
interface ReturnedValue {
  isRiseup: boolean
  primaryColor: string
  lang: string
}

export const useRiseUpClient = (): ReturnedValue => {
  const client = useContext(Client.State)
  const UserState = useContext(User.State)

  if (!client) {
    throw new Error('useRiseUpClient must be used within an Parameters provider')
  }
  return {
    isRiseup: client.riseup_client ?? false,
    primaryColor: client.mqb_primary_color || '#005eb8',
    lang: (UserState.lang || 'en').toLowerCase()
  }
}
